<dl class="ntt-detail-row">
  <dt class="ntt-detail-row__label text-md-bold">{{ label() }}</dt>
  <span class="ntt-detail-row__separator"></span>
  <dd class="ntt-detail-row__content">
    <ng-content />
  </dd>
</dl>
